import { w as withBvnPrefix } from "./keys-CwytVEYF.mjs";
import { useId as useId$1, computed, toValue } from "vue";
const useId = (id, suffix) => {
  const genId = useId$1();
  return computed(() => toValue(id) || withBvnPrefix(genId || "", suffix));
};
export {
  useId as u
};
//# sourceMappingURL=useId-vZvGlR-1.mjs.map
